import React from 'react'
import { useGetProductsQuery } from '../../services/Api'
import { BASE_URL, BASE_URL_IMAGE } from '../../services/ApiEndpoints'

import LoaderSpiner from '../../components/loaderSpiner'

const ProductPage = () => {
    const { data, isLoading } = useGetProductsQuery()
    console.log("data", data)
    const products = data?.data?.products

    return (
        <div className='py-12' >
            <div className="h-[200px]">

            </div>
            <div className="max-w-[1350px] mx-auto px-4">
                {isLoading ?
                    <div className="relative h-[70vh]">
                        <LoaderSpiner />
                    </div>
                    :
                    <div className="grid md:grid-cols-6 sm:grid-cols-2 grid-cols-2 gap-5">
                        {products?.map((item, index) => (
                            <div className='bg-bgprimary rounded-md p-2' key={index}  >
                                <img src={`${BASE_URL_IMAGE}${item?.image}`} className='w-full mb-3 h-[150px] object-cover' alt="" />
                                <p className='text-dark font-quicksand font-medium text-[12px]' > {item?.description}</p>
                            </div>
                        ))}
                    </div>
                }


            </div>
        </div>
    )
}

export default ProductPage
